// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"supportConnection_iconContainer__1Q_7H","icon":"supportConnection_icon__eZc4j"};